import React from "react";
import GcStudentMasterLayout from "../../../layouts/gcstudent/GcStudentMasterLayout";
import BookDetailPage from "../../../subsreens/gcstudent/bookdetailpage/BookDetailPage";

const GcBookDetail = () => {
    return <>
       <GcStudentMasterLayout>
        <BookDetailPage/>
       </GcStudentMasterLayout>
    </>
}

export default GcBookDetail;
